<template>
    <DexCard class="tw:p-200" elevation="flat">
        <div class="business-address-container">
            <DisplayAddress
                :name="companyProfile.companyName"
                :address1="companyProfile.address1"
                :address2="companyProfile.address2"
                :city="companyProfile.locality"
                :state="companyProfile.region"
                :zip="companyProfile.postalCode"
            />

            <DexDropdownMenu align="end">
                <template #default>
                    <DexIconButton
                        :label="$t('moreActions')"
                        name="more-vertical"
                    />
                </template>

                <template #content>
                    <DexDropdownMenuItem
                        leading-icon="briefcase"
                        @click="$emit('edit-business-profile')"
                    >
                        {{ $t('editBusinessProfile') }}
                    </DexDropdownMenuItem>
                </template>
            </DexDropdownMenu>
        </div>
    </DexCard>
</template>

<script>
import {
    DexCard,
    DexDropdownMenu,
    DexDropdownMenuItem,
    DexIconButton,
} from '@thryvlabs/dex-vue';
import { DisplayAddress } from '@keap-web/shared-ui';

export default {
    components: {
        DexCard,
        DexDropdownMenu,
        DexDropdownMenuItem,
        DexIconButton,
        DisplayAddress,
    },

    props: {
        companyProfile: {
            type: Object,
            default: () => ({}),
        },
    },

    emits: ['edit-business-profile'],
};
</script>

<style lang="scss" scoped>
.business-address-container {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    width: 100%;
}
</style>

<i18n>
{
  "en-us": {
    "moreActions": "More actions",
    "editBusinessProfile": "Edit business profile"
  }
}
</i18n>
